import { Box2, Vector2 } from "three";
import { HSLColor } from "../../../library-js/colors/HSLColor";
import { HTMLColor } from "../../../library-js/colors/HTMLColor";
import { ComparableUIProperty, UIProperty } from "../../../library-js/dom-ui/basics/UIProperty";
import { Canvas2dBase } from "../../../library-js/dom-ui/graphical/Canvas2dBase";
import { TemplateDefaults } from "../../TemplateDefaults";
import { NodeGraph } from "../model/NodeGraph";
import { Colors } from "../../../library-js/colors/Colors";
import { Box2Extensions } from "../../../library-js/geometry/Box2Extensions";

export class OverlaysLayer extends Canvas2dBase
{ 
  readonly edgeCreation      = new UIProperty<boolean>( this, false );   
  readonly edgeCreationStart = new ComparableUIProperty<Vector2>( this, new Vector2( 0, 0 ) );
  readonly edgeCreationEnd   = new ComparableUIProperty<Vector2>( this, new Vector2( 1, 1 ) );

  readonly selectionRect     = new UIProperty<boolean>( this, false );
  readonly selectionStart    = new ComparableUIProperty<Vector2>( this, new Vector2( 0, 0 ) );
  readonly selectionEnd      = new ComparableUIProperty<Vector2>( this, new Vector2( 1, 1 ) );

  _nodeGraph:NodeGraph;
  _clearBox:Box2 = new Box2( new Vector2( 0, 0 ), new Vector2( 0, 0 ) );
  _expandVector:Vector2 = new Vector2( 5, 5 );
  _lineWidth:number = 5;
  _clearBoxFilled = false;

  constructor( ng:NodeGraph, e:Element )
  {
    super( e );
    this._nodeGraph = ng;
    this.setFlags( TemplateDefaults.noPointers );
    this._linkRedraw( 
      this.edgeCreation, this.edgeCreationStart, this.edgeCreationEnd, 
      this.selectionRect, this.selectionStart, this.selectionEnd 
    );
    
  }

  _update()
  {     
    if ( this._clearBoxFilled )
    {
      this.clearBox( this._clearBox );
    }
    
    this._clearBoxFilled = false;

    for ( let i = 0; i < this.numLayers; i++ )
    {
      let box = this.renderLayer( i );

      if ( ! box )
      {
        continue;
      }

      if ( ! this._clearBoxFilled )
      {
        this._clearBox.copy( box );
      }
      else
      {
        this._clearBox.union( box );
      }

      this._clearBoxFilled = true;     

    }
    
    
  }

  get numLayers()
  {
    return 2;
  }

  renderLayer( index:number ):Box2
  {
    if ( index == 0 )
    {
      return this.drawEdgeCreation();
    }
    else if ( index == 1 )
    {
      return this.drawSelectionRect();
    }
  }

  drawEdgeCreation():Box2
  {
    if ( ! this.edgeCreation.value )
    {
      return null;
    }

    let startPosition = this.edgeCreationStart.value;
    let endPosition   = this.edgeCreationEnd.value;

    this.setLineStyle( new HSLColor( 0, 0, 100 ), this._lineWidth );    

    this.drawLine( startPosition, endPosition );    

    return Box2Extensions.createFromPoints( startPosition, endPosition, this._expandVector );
  }

  drawSelectionRect():Box2
  {
    if ( ! this.selectionRect.value )
    {
      return null;
    }

    let startPosition = this.selectionStart.value.clone();
    let endPosition   = this.selectionEnd.value.clone();

    startPosition.min( this.selectionEnd.value );
    endPosition.max( this.selectionStart.value );

    this.setLineStyle( new HSLColor( 0, 0, 100 ), this._lineWidth );    

    this.drawLineBox( startPosition, endPosition );    

    return Box2Extensions.createFromPoints( startPosition, endPosition, this._expandVector );
  }
  

  ensureCanvasSize()
  {    
    if ( ! this._nodeGraph._controller._nodeGraphEvent )
    {
      return;
    }

    if ( 

      this.canvas.width === this._nodeGraph._controller._nodeGraphEvent.size.x &&
      this.canvas.height === this._nodeGraph._controller._nodeGraphEvent.size.y 
    )
    {
      return;
    }

    this.canvas.width  =this._nodeGraph._controller._nodeGraphEvent.size.x;
    this.canvas.height = this._nodeGraph._controller._nodeGraphEvent.size.y ;

    this.dimensions.width = this._nodeGraph._controller._nodeGraphEvent.size.x;
    this.dimensions.height = this._nodeGraph._controller._nodeGraphEvent.size.y;
  }
}
